(() => {
  const uid = () => `${Date.now()}-${Math.random().toString(16).slice(2)}`;

  const getCartContainer = () =>
    document.querySelector("cart-drawer") || document.querySelector("cart-notification");

  const addSectionsPayload = (formData) => {
    const cart = getCartContainer();
    if (cart && typeof cart.getSectionsToRender === "function") {
      const sectionIds = cart.getSectionsToRender().map((s) => s.id);
      formData.set("sections", sectionIds);
      formData.set("sections_url", window.location.pathname);
    }
  };

  const renderCart = (lastResponse) => {
    const cartDrawer = document.querySelector("cart-drawer");
    const cartNotification = document.querySelector("cart-notification");

    if (cartDrawer && typeof cartDrawer.renderContents === "function") {
      cartDrawer.renderContents(lastResponse);
      cartDrawer.open?.();
      return;
    }

    if (cartNotification && typeof cartNotification.renderContents === "function") {
      cartNotification.renderContents(lastResponse);
      return;
    }

    window.location.href = "/cart";
  };

  document.addEventListener(
    "submit",
    async (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('form[action^="/cart/add"]')) return;
      if (form.dataset.splitLineItems !== "true") return;

      const qtyInput = form.querySelector('[name="quantity"]');
      const qty = Math.max(1, parseInt(qtyInput?.value || "1", 10));

      // Always add a UID, even for qty=1 (keeps future edits stable)
      e.preventDefault();
      e.stopImmediatePropagation();

      // Build a "base" FormData copy of the form
      const base = new FormData(form);

      // Force 1 per add request
      base.set("quantity", "1");

      let lastJson = null;

      try {
        for (let i = 0; i < qty; i++) {
          const fd = new FormData();
          for (const [k, v] of base.entries()) fd.append(k, v);

          // Unique per ring => prevents merge
          fd.set("properties[_ring_uid]", uid());

          // Ensure Dawn cart drawer updates
          addSectionsPayload(fd);

          const res = await fetch(`${window.routes?.cart_add_url || "/cart/add"}.js`, {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            },
            body: fd,
          });

          if (!res.ok) {
            const text = await res.text();
            throw new Error(text || "Cart add failed");
          }

          lastJson = await res.json();
        }

        if (lastJson) renderCart(lastJson);
      } catch (err) {
        console.error("Split line items add failed:", err);
        window.location.href = "/cart";
      }
    },
    true // capture, so we stop Dawn's default handler cleanly
  );
})();